export default __webpack_public_path__ + "static/team-home-ab94dad3abaa4dedc36f21c596b183ce.png";